import { COMPONENTS, CoreConfig, DeepPartial, SLOTS } from '@empathybroker/ebx-gluon';
import { Vue } from 'vue-property-decorator';

export const MOBILE_CORE_CONFIG: DeepPartial<CoreConfig> = {
  template: COMPONENTS.TEMPLATES.MaxWidthTemplate,
  components: {
    ColumnsPicker: null,
    EmptySearch: null,
    NoResults: {
      children: {
        img: {
          component: 'TuandcoNoResultsImage'
        }
      }
    },
    RelatedTags: {
      data: {
        slot: SLOTS.template.toolbar
      }
    },
    ResultsNumber: null,
    Sort: {
      data: {
        slot: SLOTS.template.footer
      }
    },
    SortList: null
  }
};
export const DESKTOP_CORE_CONFIG: DeepPartial<CoreConfig> = {
  template: COMPONENTS.TEMPLATES.MaxWidthTemplate,
  components: {
    clearSelectedFilters: null,
    ClearFilters: null,
    CloseFacetsGroup: null,
    GroupSelectedFilters: null,
    Sort: {
      data: {
        slot: SLOTS.template.header
      }
    },
    NoResults: {
      children: {
        imagesMenu: {
          component: 'TuandcoImageMenu'
        }
      }

    },
    ToggleFacetsGroups: null,
  }
};
